import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { MatRadioChange                                 } from '@angular/material/radio';
import { Radio                                          } from 'src/app/interface/radio/radio';

@Component({
  selector: 'custom-radio',
  templateUrl: './custom.radio.html',
  styleUrls: ['./custom.radio.scss']
})
export class CustomRadio implements OnInit, Radio {

  @Input()  forceDisabled : boolean = false;
  @Input()  vertical      : boolean = false;

  @Input() autoSelectFirst: boolean = false

  @Input() title_none     : string  
  @Input() title_single   : string  
  @Input() title_multiple : string  

  @Input() values         : any[]
  @Input() selected       : any
  currentValue: any

  @Output() change: EventEmitter<MatRadioChange> = new EventEmitter<MatRadioChange>()

  constructor() { }

  async ngOnInit() 
  {
    if  (this.values          ) this.retriveValues  (this.values  ) 
    if  (this.autoSelectFirst ) this.selectFirst    (             )   
    if  (this.selected        ) this.selectElement  (this.selected)
  }

  getSelectedValue() {
    return this.currentValue
  }

  setSelectedValue(value: any): void 
  {
    this.currentValue = value

    this.change.emit(value)
  }

  clearSelectedValue(): void 
  {
    this.setSelectedValue (undefined)
  }

  selectFirst (): void 
  {
    if ( this.values && this.values.length > 0) {
      this.setSelectedValue( this.values[0] )    
    }
  }

  selectElement(el: any): void 
  {
    const find = this.searchElement(el)    
    if (find) this.setSelectedValue(find) 
  }

  selectElementByPos(pos: number): void 
  {
    if (!this.values) return
    if (this.values.length <= pos) return

    this.setSelectedValue(this.values[pos]) 
  }

  searchElement(elem: any): any
  {
    if (!this.values) return undefined    
    return this.values.find ( (el) => elem.value == el.value ) 
  }

  retriveValues( values: any []){
    this.values = values
  }

  onChange(rbChange: MatRadioChange) 
  {
    this.setSelectedValue(rbChange.value)  
  }

  isDisabled(): boolean
  {
    return      this.forceDisabled 
            ||  !this.values
            ||  this.values.length <= 1
  }

  getLength(): number
  {
    if ( !this.values ) return -1
     return this.values.length
  }

  hasLabel(){
    return this.title_none || this.title_single || this.title_multiple 
  }
}
